import { render, staticRenderFns } from "./IconCategoria.vue?vue&type=template&id=4fb47520&scoped=true"
import script from "./IconCategoria.vue?vue&type=script&lang=js"
export * from "./IconCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb47520",
  null
  
)

export default component.exports